/* global $ */
import { Select } from '@bag'
import Api from './Api'

export default class Pagination extends Api {
  constructor(el, opt) {
    super(el, opt)
    this.init()
  }

  init() {
    const unit = this.renderPage()
    Object.assign(this, { unit })
    this.update(this.settings.data)
    const pe = unit.find('.pagination__editor input')
    pe.change(() => {
      const data = this.data
      const { totalPage, firstIndex, pageCount } = data
      if (pe.val() > Number(totalPage || 0)) {
        pe.val(Number(totalPage || 0))
      }
      if (pe.val() < Number(firstIndex || 0)) {
        pe.val(Number(firstIndex || 0))
      }
      if ($.type(this._pageChange) === 'function') {
        this._pageChange(Object.assign(data, { indexPage: Number(pe.val()) }))
      }
    })
    this.se.change(() => {
      const data = this.data
      if ($.type(this._pageChange) === 'function') {
        this._pageChange(Object.assign(data, { indexPage: 1, pageCount: Number(this.se.value) }))
      }
    })
  }

  pageChange(fn) {
    this._pageChange = fn
  }

  renderPage() {
    const unit = $(`
    <div class="pagination">
      <span class="pagination__total">共 0 条</span>
      <span class="pagination__total-page">共 0 页</span>
      <span class="pagination__sizes"></span>
      <button type="button" class="btn-prev"><i class="icon fa fa-angle-left"></i></button>
      <ul class="lt-pager"></ul>
      <button type="button" disabled="disabled" class="btn-next"><i class="icon fa fa-angle-right""></i></button>
      <span class="pagination__jump">前往<div class="lt-input pagination__editor is-in-pagination">
          <input type="number" autocomplete="off" min="1" max="4" class="input__inner">
        </div>页</span>
    </div>`)
    const ps = unit.find('.pagination__sizes')
    const se = new Select({ size: 'mini', clearable: false })
    se.unit.find('.select-dropdown').css({ 'min-width': 110 })
    ps.append(se.unit)
    Object.assign(this, { se })

    unit.click((e) => {
      const bq = $(e.target).closest('.btn-prev')
      const bn = $(e.target).closest('.btn-next')
      if (bq.length > 0) {
        if ($.type(this._pageChange) === 'function') {
          const data = this.data
          const { indexPage } = data
          this._pageChange(Object.assign(data, { indexPage: Number(indexPage) - 1 }))
        }
      } else if (bn.length > 0) {
        if ($.type(this._pageChange) === 'function') {
          const data = this.data
          const { indexPage } = data
          this._pageChange(Object.assign(data, { indexPage: Number(indexPage) + 1 }))
        }
      }
    })
    return unit
  }

  update(data) {
    const cl = [
      { id: '5', text: '5条/页' },
      { id: '10', text: '10条/页' },
      { id: '20', text: '20条/页' },
      { id: '40', text: '40条/页' }
    ]
    const { totalCount, pageCount, totalPage, indexPage, firstIndex } = data
    const { se, unit } = this
    // 1. 共几条
    unit.find('.pagination__total').text(`共 ${totalCount} 条`)
    unit.find('.pagination__total-page').text(`共 ${totalPage} 页`)
    // 2. 步长
    if (cl.filter(({ id }) => Number(id) === Number(pageCount)).length === 0) {
      const pc = { id: `${pageCount}`, text: `${pageCount}条/页` }
      cl.unshift(pc)
    }
    se.data = cl
    se.value = String(pageCount)
    // 3.总页数
    const pg = unit.find('.lt-pager').empty()
    const pd = $('<div></div>')
    const tpg = Number(totalPage) || 1
    const ipg = Number(indexPage)
    let num = 7
    let key = 0
    if (tpg > 7) {
      if (ipg > 4) {
        key = ipg - 4
        num = 7 + key
      }
      if (num > tpg) {
        num = tpg
        key = tpg - 7
      }
    } else {
      num = tpg
    }
    for (let i = key; i < num; i++) {
      const po = $(`<li class="number">${i + 1}</li>`)
      if (Number(indexPage) === i + 1) {
        po.addClass('active')
      }
      pd.append(po)
    }
    const bp = unit.find('.btn-prev')
    if (Number(indexPage) === 1) {
      bp.prop('disabled', true)
    } else {
      bp.prop('disabled', false)
    }
    const bn = unit.find('.btn-next')
    if (Number(indexPage) === Number(totalPage || 1)) {
      bn.prop('disabled', true)
    } else {
      bn.prop('disabled', false)
    }
    pg.append(pd.children())
    // 4.跳转
    const pe = unit.find('.pagination__editor input')
    pe.val(Number(indexPage))
    pe.attr('min', Number(firstIndex || 0))
    pe.attr('max', Number(totalPage || 1))
    pg.unbind('click').bind('click', (e) => {
      const page = $(e.target).closest('li')
      if (page.length > 0) {
        if ($.type(this._pageChange) === 'function') {
          this._pageChange(Object.assign(data, { indexPage: Number(page.text()) }))
        }
      }
    })
  }
}
